import moment from "moment"
import Holidays from "date-holidays"
import parkLogoPath from "../../../../assets/images/park_logo__green.svg"
import parkIconPath from "../../../../assets/images/park_icon__green.svg"

const checkForTodayHoliday = (targetDate: moment.Moment) => {
  const weekBeforeTarget = moment(targetDate).subtract(7, "days")
  const twoDaysAfterTarget = moment(targetDate).add(2, "days")

  return moment().isBetween(weekBeforeTarget, twoDaysAfterTarget)
}

const fetchParkLogoSrc = () => {
  const holidays = new Holidays("US")

  const holidayLogos = {
    "Christmas Day": "christmas_logo.png",
    "Halloween": "halloween_logo.png",
    "Thanksgiving Day": "thanksgiving_logo.png",
    "Easter Sunday": "easter_logo.png",
    "Independence Day": "4th_of_july_logo.png",
  }

  const observedHolidayNames = Object.keys(holidayLogos)
  const observedHolidays = holidays.getHolidays(moment().year()).filter((h) => observedHolidayNames.includes(h.name))

  for (const holiday of observedHolidays) {
    if (checkForTodayHoliday(moment(holiday.date)) && holidayLogos[holiday.name]) {
      return `https://park-prod-assets.s3.amazonaws.com/camps/logos/${holidayLogos[holiday.name]}`
    }
  }

  return window.innerWidth > 500 ? parkLogoPath : parkIconPath
}

export default fetchParkLogoSrc
